export default __webpack_public_path__ + "static/media/logo7.77b54628.png";